import { useOpenClose } from '@evertrue/et-components';
import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const SignalVideoModalContext = createContext();

export const SignalVideoModalProvider = ({ children }) => {
  const [modalView, setModalView] = useState({ view: '', prev: '' });
  const [isThankviewModalOpen, openThankviewModal, closeThankviewModal] = useOpenClose();

  const handleChangeModalView = (view, prev) => {
    if (view === 'prev') {
      setModalView({ view: modalView.prev || 'library', prev: modalView.view });
    } else {
      setModalView({ view, prev: prev || modalView.view || '' });
    }
  };

  const handleCloseThankviewModal = (onClose = () => {}) => {
    closeThankviewModal();
    setModalView({ view: '', prev: '' });
    onClose();
  };

  const handleOpenThankviewModal = (view = 'library', prev) => {
    if (view) {
      handleChangeModalView(view, prev);
    }
    openThankviewModal();
  };

  const value = {
    modalView,
    handleChangeModalView,
    isThankviewModalOpen,
    handleOpenThankviewModal,
    handleCloseThankviewModal,
  };

  return <SignalVideoModalContext.Provider value={value}>{children}</SignalVideoModalContext.Provider>;
};

export const useSignalVideoModalContext = () => {
  return useContext(SignalVideoModalContext);
};

SignalVideoModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default useSignalVideoModalContext;
